import { useMoney } from "../../web/lib/money";

/**
 * What a save changes, as its save bar and its question both say it: "Price: $133.00 → $146.00", and under it "Cost: $41.80 →
 * $87.26" (each only when it changes; with its tax, `label`, when that changes too).
 */
export function ChangeLines(
    props: Readonly<{ price?: { from: string; to: string; fromLabel?: string; toLabel?: string }; cost?: { from: string; to: string; label?: string } }>,
) {
    const fmt = useMoney();
    const line = (what: string, from: string, to: string, fromLabel?: string, toLabel?: string) => (
        <span className="block">
            {what}: <span className="tabular-nums">{fmt.money(from)}</span>
            {fromLabel ? ` ${fromLabel}` : ""} → <span className="font-semibold text-ink tabular-nums">{fmt.money(to)}</span>
            {toLabel ? ` ${toLabel}` : ""}
        </span>
    );
    return (
        <>
            {props.price ? line("Price", props.price.from, props.price.to, props.price.fromLabel, props.price.toLabel) : null}
            {props.cost ? line("Cost", props.cost.from, props.cost.to, props.cost.label, props.cost.label) : null}
        </>
    );
}
